module.exports = __webpack_public_path__ + "static/media/bannerImg.d2428f42.png";